import { connect } from 'react-redux';
import { translate } from '../../../base/i18n/functions';
import { IconFlipImage } from '../../../base/icons/svg';
import AbstractButton from '../../../base/toolbox/components/AbstractButton';
import { updateSettings } from '../../../base/settings/actions';
import { NOTIFY_CLICK_MODE } from '../../types';
import { getParticipantMenuButtonsWithNotifyClick } from '../../functions.web';
import { getLocalParticipant } from '../../../base/participants/functions';
import { PARTICIPANT_MENU_BUTTONS as BUTTONS } from '../../../video-menu/constants';
import { MY_SETTINGS_TOOLBOX_VISIBLE } from '../../actionTypes';
/**
 * Implementation of a button for toggling fullscreen state.
 */
class FlipImageButton extends AbstractButton {
    constructor() {
        super(...arguments);
        this.accessibilityLabel = 'toolbar.accessibilityLabel.flipImage';
        this.label = 'toolbar.flipImage';
        this.tooltip = 'toolbar.flipImage';
        this.icon = IconFlipImage;
    }
    /**
     * Indicates whether this button is in toggled state or not.
     *
     * @override
     * @protected
     * @returns {boolean}
     */
    _isToggled() {
        return this.props._localFlipX;
    }
    /**
    * Handles clicking the button, and toggles fullscreen.
    *
    * @private
    * @returns {void}
    */
    _handleClick() {
        const { _localFlipX, dispatch, notifyClick, notifyMode } = this.props;
        notifyClick?.(BUTTONS.FLIP_LOCAL_VIDEO);
        if (notifyMode === NOTIFY_CLICK_MODE.PREVENT_AND_NOTIFY) {
            return;
        }
        dispatch(updateSettings({
            localFlipX: !_localFlipX
        }));
        dispatch({
            mySettingsVisible: false,
            type: MY_SETTINGS_TOOLBOX_VISIBLE
        });
    }
}
/**
 * Function that maps parts of Redux state tree into component props.
 *
 * @param {Object} state - Redux state.
 * @returns {Object}
 */
const mapStateToProps = (state) => {
    const { localFlipX } = state['features/base/settings'];
    const buttonsWithNotifyClick = getParticipantMenuButtonsWithNotifyClick(state);
    const localParticipant = getLocalParticipant(state);
    const _localParticipantId = localParticipant?.id ?? '';
    const _notifyMode = buttonsWithNotifyClick?.get(BUTTONS.FLIP_LOCAL_VIDEO);
    const _notifyClick = (buttonKey) => {
        try {
            const notifyMode = buttonsWithNotifyClick?.get(buttonKey);
            if (!notifyMode) {
                // Error return code 1: No notify mode found for this button
                return { success: false, code: 1, message: 'No notify mode found for the button.' };
            }
            // Call the API, or return an error code if unsuccessful
            APP.API.notifyParticipantMenuButtonClicked(buttonKey, _localParticipantId, notifyMode === NOTIFY_CLICK_MODE.PREVENT_AND_NOTIFY);
            // Success return code
            return { success: true, code: 0, message: 'Notification sent successfully.' };
        }
        catch (error) {
            // Error return code 2: Exception occurred
            return { success: false, code: 2, message: `Error: ${error.message}` };
        }
    };
    return {
        _localFlipX: Boolean(localFlipX),
        notifyClick: _notifyClick,
        notifyMode: _notifyMode
    };
};
export default translate(connect(mapStateToProps)(FlipImageButton));
